export default __webpack_public_path__ + "static/media/work4image3.ead6f0a0.png";